import {Provider, Region, ThunkResult, RegionInfo} from 'js/types'

import {getRegionInfo, getProviderInfo} from '../selectors'

type ProviderRegionThunkResult<R> = ThunkResult<R, Action>

export type Action = SetProviderInfoAction | SetRegionInfoAction

export interface SetProviderInfoAction {
  type: 'SET_PROVIDER_INFO'
  payload: {
    provider: Provider
  }
}

export const setProviderInfo = (provider: Provider): SetProviderInfoAction => ({
  type: 'SET_PROVIDER_INFO',
  payload: {provider},
})

export interface SetRegionInfoAction {
  type: 'SET_REGION_INFO'
  payload: {
    region: Region
  }
}

export const setRegionInfo = (region: Region): SetRegionInfoAction => ({
  type: 'SET_REGION_INFO',
  payload: {region},
})

export const updateRegionInfo =
  (regionInfo: RegionInfo): ProviderRegionThunkResult<void> =>
  (dispatch, getState) => {
    const currentRegionInfo = getRegionInfo(getState())

    if (currentRegionInfo.region !== regionInfo.region) {
      dispatch(setRegionInfo(regionInfo.region))
    }
  }

export const updateProviderInfo =
  (provider: Provider): ProviderRegionThunkResult<void> =>
  (dispatch, getState) => {
    const providerInfo = getProviderInfo(getState())

    if (providerInfo.provider !== provider) {
      dispatch(setProviderInfo(provider))
    }
  }
